import { Popover, PopoverContent, PopoverTrigger } from '@klear/ui/components/popover'
import { Button } from '@klear/ui/components/button'
import EventStatus from '@klear/order-event-ui/event-status'

export default function EventStatusBadge({
  eventId,
  orderId,
  statusLabel
}: {
  eventId: number
  orderId: number
  statusLabel: string
}) {
  return (
    <Popover>
      <PopoverTrigger asChild>
        <Button variant="outline" size="xs">
          {statusLabel}
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-[600px]">
        <EventStatus eventId={eventId} orderId={orderId} />
      </PopoverContent>
    </Popover>
  )
}
